<ul class="nav nav-tabs" role="tablist">
  <ng-container *ngIf="!isEdit">
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': nameMenu === 'information_general'}"
        routerLink="/{{branchofficeSlug}}/turismo/paquetes/nuevo">
        <span class="d-none d-md-block">Información general</span><span class="d-block d-md-none"><i
            class="fas fa-info h5"></i></span>
      </a>
    </li>
  </ng-container>
  <ng-container *ngIf="isEdit">   
    <ng-container *ngIf="!isCotization">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'information_general'}"
          routerLink="/{{branchofficeSlug}}/turismo/paquetes/editar/{{checkId}}">
          <span class="d-none d-md-block">Información general</span><span class="d-block d-md-none"><i
              class="fas fa-info h5"></i></span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'gallery_image'}"
          routerLink="/{{branchofficeSlug}}/turismo/paquetes/imagenes/{{checkId}}">
          <span class="d-none d-md-block">Galería fotos</span><span class="d-block d-md-none"><i
              class="far fa-file-image h5"></i></span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'gallery_video'}"
          routerLink="/{{branchofficeSlug}}/turismo/paquetes/videos/{{checkId}}">
          <span class="d-none d-md-block">Galería iframe videos</span><span class="d-block d-md-none"><i
              class="fas fa-file-video h5"></i></span>
        </a>
      </li>
      <li class="nav-item">
        <!-- <a class="nav-link" [ngClass]="{'active': nameMenu === 'gallery_video'}"
          routerLink="/{{branchofficeSlug}}/turismo/paquetes/videos/{{checkId}}">
          <span class="d-none d-md-block">Galería iframe videos</span><span class="d-block d-md-none"><i
              class="fas fa-file-video h5"></i></span>
        </a> -->
        <a class="btn pointer bold" style="padding: 5px;color: rgb(241, 16, 143)" target="_blank"
          href="/{{branchofficeSlug}}/api/packagetour/descargar/pdf/{{checkId}}">
          <!-- <span class="d-none d-md-block">Descargar</span> -->
          PDF <i class="far fa-file-pdf h5 m-t-2"></i>
        </a>
      </li>
    </ng-container>
    <ng-container *ngIf="isCotization">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': nameMenu === 'information_general'}"
          routerLink="/{{branchofficeSlug}}/turismo/cotizaciones/editar/{{checkId}}">
          <span class="d-none d-md-block">Información general</span><span class="d-block d-md-none"><i
              class="fas fa-info h5"></i></span>
        </a>
      </li>
      <li class="nav-item">
        <a class="btn pointer bold" style="padding: 5px;color: rgb(241, 16, 143)" target="_blank"
          href="/{{branchofficeSlug}}/api/cotizacion/descargar/pdf/{{checkId}}">
          <!-- <span class="d-none d-md-block">Descargar</span> -->
          COT PDF <i class="far fa-file-pdf h5 m-t-2"></i>
        </a>
      </li>
    </ng-container>
  </ng-container>
</ul>
